import CoursesBox from "./CoursePage";

export default CoursesBox;
